/* eslint-disable react/prop-types */
import { ButtonPrimary } from 'components/Button'
import Column from 'components/Column'
import { CHAIN_IDS_TO_NAMES, defaultChainId, SupportedChainId } from 'config/chains'
import { useConnection } from 'hooks/useConnection'
import { FarmErrors } from 'lib/hooks/kodiakFarms/useFarmAction'
import { Text } from 'rebass'

import { CardContent, Container, LoaderIcon, StatusIndicator, StatusText, StatusWrapper } from './styled'
import { FlexBetween } from './styled'

const StatusCard: React.FC<{
  status: 'active' | 'not_started'
  onStart: () => void
  isStarting: boolean
  errors: FarmErrors
}> = ({ status, onStart, isStarting, errors }) => {
  const { chainId } = useConnection()
  const chainName = chainId ? CHAIN_IDS_TO_NAMES[chainId as SupportedChainId] : CHAIN_IDS_TO_NAMES[defaultChainId()]
  const handleBuyClick = (tokenAddress: string) => {
    const swapUrl = `https://app.kodiak.finance/#/swap?chain=${chainName}&inputCurrency=bera&outputCurrency=${tokenAddress}`
    window.open(swapUrl, '_blank')
  }

  // const renderError = (error: FarmError) => {
  //   if (!error) return null
  //   if (error.type === 'BALANCE_ERROR') {
  //     return (
  //       <InfoAlert>
  //         <Info size={20} />
  //         <InfoText>
  //           Insufficient {error.symbol} balance
  //           <br />
  //           Required: {error.required} {error.symbol}
  //           <br />
  //           Available: {error.available} {error.symbol}
  //         </InfoText>
  //         <ButtonSecondary
  //           onClick={() => handleBuyClick(error.token)}
  //           width="fit-content"
  //           padding="8px 12px"
  //           style={{ marginTop: '8px' }}
  //         >
  //           Buy {error.symbol}
  //         </ButtonSecondary>
  //       </InfoAlert>
  //     )
  //   }

  //   //   if (error.type === 'VALIDATION_ERROR') {
  //   //     return (
  //   //       <InfoAlert>
  //   //         <Info size={20} />
  //   //         <InfoText>{error.message}</InfoText>
  //   //       </InfoAlert>
  //   //     )
  //   //   }

  //   //   return null
  // }

  return (
    <Container>
      <CardContent>
        <Column gap="1rem">
          <FlexBetween>
            <div>
              <Text fontWeight={600} fontSize="1.25rem">
                Farm Status
              </Text>
              <StatusWrapper>
                <StatusIndicator status={status} />
                <StatusText>{status === 'active' ? 'Active' : 'Not Started'}</StatusText>
              </StatusWrapper>
            </div>

            {status === 'not_started' && (
              <ButtonPrimary onClick={onStart} width="auto" disabled={isStarting}>
                {isStarting && <LoaderIcon size={16} />}
                {isStarting ? 'Starting Farm...' : 'Start Farm'}
              </ButtonPrimary>
            )}
          </FlexBetween>

          {errors.error?.type === 'BALANCE_ERROR' && (
            <Text fontSize="14px" color="textSecondary">
              Please ensure you have sufficient token balances
            </Text>
          )}
        </Column>
      </CardContent>
    </Container>
  )
}

export default StatusCard
